export default "__VITE_ASSET__239ed5da__"